
export default [
    {
        path: '/',
        name: 'index',
        component: () => import('@/views/Pages/Home.vue')
    },
    {
        path: '/Rccl.Cruise/CruiseSearch/Search',
        name: 'CruiseSearch',
        component: () => import('@/views/Cruise/CruiseSearch.vue')
    },
    {
        path: '/Rccl.Cruise/CruiseDetail',
        name: 'CruiseDetail',
        component: () => import('@/views/Cruise/CruiseDetail.vue')
    },
    {
        path: '/Rccl.Booking/Booking/GuestInfo',
        name: 'GuestInfo',
        component: () => import('@/views/Booking/GuestInfo.vue')
    },
    {
        path: '/Rccl.Booking/Booking/Pay',
        name: 'Pay',
        component: () => import('@/views/Booking/Pay.vue')
    },
    {
        path: '/Rccl.Booking/Booking/PayByMethod',
        name: 'PayByMethod',
        props: true,
        component: () => import('@/views/Booking/PayByMethod.vue')
    },
    {
        path: '/Rccl.Booking/Booking/PaySuccess',
        name: 'PaySuccess',
        component: () => import('@/views/Booking/PaySuccess.vue')
    },
    {
        path: '/Rccl.Booking/Booking/PaySuccessBack',
        name: 'PaySuccessBack',
        props: true,
        component: () => import('@/views/Booking/PaySuccessBack.vue')
    },
    {
        path: '/Rccl.Booking/Booking/BookingSearch',
        name: 'BookingSearch',
        component: () => import('@/views/Booking/BookingSearch.vue')
    },
    {
        path: '/Rccl.Booking/Booking/BookingDetail',
        name: 'BookingDetail',
        component: () => import('@/views/Booking/BookingDetail.vue')
    },
    {
        path: '/Rccl.Booking/OpenBooking/Detail',
        name: 'OpenBookingDetail',
        component: () => import('@/views/Booking/OpenBookingDetail.vue')
    },
    {
        path: '/Rccl.Booking/Booking/OpenBookingPay',
        name: "OpenBookingPayByMethod",
        props: true,
        component: () => import('@/views/Booking/OpenBookingPayByMethod.vue')
    },
    {
        path: '/Rccl.Booking/Booking/OpenBookingPaySuccess',
        name: "OpenBookingPaySuccess",
        component: () => import('@/views/Booking/OpenBookingPaySuccess.vue')
    },
    {
        path: '/Orchard.Rccl.Users/Login/Login',
        name: 'Login',
        component: () => import('@/views/User/Login.vue')
    },
    {
        path: '/Orchard.Rccl.Users/Auth/Index',
        name: 'Auth',
        component: () => import('@/views/User/Auth.vue')
    },
    {
        path: '/Rccl.Partner/Partner/Index',
        name: 'PartnerIndex',
        component: () => import('@/views/Partner/PartnerIndex.vue')
    },
    {
        path: '/Rccl.Partner/Partner/Register',
        name: 'PartnerRegister',
        component: () => import('@/views/Partner/PartnerRegister.vue')
    },
    {
        path: '/Rccl.Partner/Partner/Login',
        name: 'PartnerLogin',
        component: () => import('@/views/Partner/PartnerLogin.vue')
    },
    {
        path: '/Rccl.Partner/Partner/Active',
        name: 'PartnerActive',
        component: () => import('@/views/Partner/PartnerActive.vue')
    },
    {
        path: '/Orchard.Rccl.Users/WeChatBanding/WeChatChoose',
        name: 'WechatBind',
        component: () => import('@/views/User/WechatBind.vue')
    },
    {
        path: '/Orchard.Rccl.Users/WeChatBanding/Login',
        name: 'WechatLogin',
        component: () => import('@/views/User/WechatLogin.vue')
    },
    {
        path: '/Rccl.UserCenter/OrderRecord/List',
        name: 'BookingListPage',
        component: () => import('@/views/Booking/BookingListPage.vue')
    },
    {
        path: '/content/faq',
        name: 'Faq',
        component: () => import('@/views/Pages/Faq.vue')
    },
    {
        path: '/content/taste/ships/:shipCode',
        name: 'ShipDetail',
        component: () => import('@/views/Ships/ShipDetail.vue')
    },
    {
        path: '/content/taste/taste',
        name: 'ShipExperiencePage',
        component: () => import('@/views/Ships/ShipExperiencePage.vue')
    },
    {
        path: '/Rccl.CustomPage/Faq/Detail/:id.html',
        name: 'FaqDetail',
        component: () => import('@/views/Pages/FaqDetail.vue')
    },
    {
        path: '/Rccl.Hr/Recruitment/Index',
        name: 'RecruitmentIndex',
        component: () => import('@/views/Recruitment/Index.vue')
    },
    {
        path: '/Rccl.Hr/Recruitment/Search',
        name: 'RecruitmentSearch',
        component: () => import('@/views/Recruitment/Search.vue')
    },
    {
        path: '/Rccl.Hr/Recruitment/Detail',
        name: 'RecruitmentDetail',
        component: () => import('@/views/Recruitment/Detail.vue')
    },
    {
        path: '/Rccl.UserCenter/CustomerInfo/Info',
        name: 'UserCenter',
        component: () => import('@/views/UserCenter/UserCenter.vue')
    },
    {
        path: '/Rccl.UserCenter/CustomerInfo/SignUpReward',
        name: 'SignUpReward',
        component: () => import('@/views/UserCenter/SignUpReward.vue')
    },
    {
        path: '/Rccl.UserCenter/UserCoupon/UserCoupon',
        name: 'UserCoupon',
        component: () => import('@/views/UserCenter/UserCoupon.vue')
    },
    {
        path: '/Rccl.UserCenter/WishList/List',
        name: 'UserWish',
        component: () => import('@/views/UserCenter/UserWish.vue')
    },
    {
        path: '/Rccl.UserCenter/CustomerInfo/EditInfo',
        name: 'EditInfo',
        component: () => import('@/views/UserCenter/EditInfo.vue')
    },
    {
        path: '/Rccl.UserCenter/UserContact/List',
        name: 'UserContact',
        component: () => import('@/views/UserCenter/UserContact.vue')
    },
    {
        path: '/Rccl.Review/Travel/tn-:countryName-:shipName-:orderBy-:offset-9.html',
        name: 'TravelNotesIndex',
        component: () => import('@/views/Review/TravelNotesIndex.vue')
    },
    {
        path: '/Rccl.Review/Travel/d-:countryName-:shipName-:orderBy-:offset-:id.html',
        name: 'TravelNotesDetail',
        component: () => import('@/views/Review/TravelNotesDetail.vue')
    },
    {
        path: '/Rccl.CustomPage/RcclNews',
        name: 'RcclNewsIndex',
        component: () => import('@/views/CustomPage/RcclNewsIndex.vue')
    },
    {
        path: '/Rccl.CustomPage/RcclNews/Detail/:id.html',
        name: 'RcclNewsDetail',
        component: () => import('@/views/CustomPage/RcclNewsDetail.vue')
    },
    {
        path: '/Rccl.CustomPage/Country/CountryList',
        name: 'CountryList',
        component: () => import('@/views/CustomPage/CountryList.vue')
    },
    {
        path: '/Rccl.CustomPage/ShorexIntro/ShorexIntroList',
        name: 'ShorexIntroList',
        component: () => import('@/views/CustomPage/ShorexIntroList.vue')
    },
    {
        path: '/Rccl.CustomPage/MediaCenter',
        redirect: '/Rccl.CustomPage/MediaCenter/Index'
    },
    {
        path: '/Rccl.CustomPage/MediaCenter/Index',
        name: 'MediaCenterIndex',
        component: () => import('@/views/MediaCenter/Index.vue')
    },
    {
        path: '/Rccl.CustomPage/questionnaire/SurveyQuestion',
        name: 'SurveyQuestion',
        component: () => import('@/views/Booking/SurveyQuestion.vue')
    },
    {
        path: '/shoppingmall/search',
        name: 'shoppingMallSearch',
        component: () => import('@/views/ShoppingMall/Search.vue')
    },
    {
        path: '/Rccl.Olci/Olci/CheckInIndex',
        name: 'CheckInIndex',
        component: () => import('@/views/Olci/CheckInIndex.vue')
    },
    {
        path: '/Rccl.Olci/Olci/MobileNewCheckIn',
        name: 'MobileNewCheckIn',
        component: () => import('@/views/Olci/MobileNewCheckIn.vue')
    },
    {
        path: '*',
        name: 'page-content',
        component: () => import('@/views/Pages/PageContent.vue')
    },
    {
        path: '/Orchard.Rccl.Users/Login/RecommendLogin',
        name: 'RecommendLogin',
        component: () => import('@/views/UserCenter/RecommendLogin.vue')
    },
    {
        path: '/Rccl.Booking/Booking/InvoiceDetails',
        name: 'InvoiceDetails',
        component: () => import('@/views/Invoice/InvoiceDetails.vue')
    },
    {
        path: '/Rccl.Booking/Booking/InvoiceDetailsProgress',
        name: 'InvoiceDetailsProgress',
        component: () => import('@/views/Invoice/InvoiceDetailsProgress.vue')
    },
    // {
    //     path: '/Rccl.CustomPage/MICE',
    //     name: 'MICE',
    //     component: () => import('@/views/Pages/Mice.vue')
    // },
    {
        path: '/Rccl.UserCenter/Privacy',
        name: 'Privacy',
        component: () => import('@/views/Pages/Privacy.vue')
    },
    {
        path: '/Rccl.UserCenter/RewardRule',
        name: 'RewardRule',
        component: () => import('@/views/Pages/RewardRule.vue')
    },
    {
        path: '/Rccl.UserCenter/HistoricalAgreementList',
        name: 'HistoricalAgreementList',
        meta: {
            title: "历史版本"
        },
        component: () => import('@/views/Pages/HistoricalAgreementList.vue')
    },
    {
        path: '/Rccl.UserCenter/HistoricalAgreementDetails',
        name: 'HistoricalAgreementDetails',
        component: () => import('@/views/Pages/HistoricalAgreementDetails.vue')
    },
    {
        path: '/Rccl.Cruise/CruiseSearch/SearchRow',
        name: 'CruiseSearchRow',
        component: () => import('@/views/Cruise/CruiseSearchRow.vue')
    },
]
